import CloseIcon from "@mui/icons-material/Close";
import { ResponseFormatNote, responseJsonData } from "../../../Utils/common";
import { HeaderContainer } from "../../CreateForm/DialogBase/styled";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ThemeProvider,
  createTheme,
} from "@mui/material";

const theme = createTheme({
  components: {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid lightgrey",
          fontSize: 20,
          fontWeight: 400,
          fontFamily: `"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
            "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
            "Helvetica Neue", sans-serif;`,
          padding: "15px",
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "15px",
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "15px",
        },
      },
    },
  },
});

export default function ResponseFormatModal({ closeHandler, isOpen }: any) {
  return (
    <ThemeProvider theme={theme}>
      <Dialog open={isOpen} scroll="paper" maxWidth="xs">
        <DialogTitle>
          <HeaderContainer>
            Sample Response
            <IconButton onClick={closeHandler}>
              <CloseIcon />
            </IconButton>
          </HeaderContainer>
        </DialogTitle>
        <DialogContent>
          <pre style={{ margin: "10px" }}>
            {JSON.stringify(responseJsonData, null, 2)}
          </pre>
        </DialogContent>
        <DialogActions>
          <ResponseFormatNote />
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
